import { render, staticRenderFns } from "./_totalProductExpired.vue?vue&type=template&id=c320624c&scoped=true&"
import script from "./_totalProductExpired.vue?vue&type=script&lang=js&"
export * from "./_totalProductExpired.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c320624c",
  null
  
)

export default component.exports